<script>
    import { onMount } from "svelte";
    import * as api from "../utiles/api";
    import { push } from "svelte-spa-router";
    import Btm from "../components/Btm.svelte";
    import * as common from "../utiles/common.util";

    export let params;
    let cmpn_id = params.cmpn_id;

    let name = "";
    let owner = "";
    let tel = "";
    let addr = "";
    let bizno = "";
    let note = "";

    onMount(() => {
        getData();
    });

    async function getData() {
        const response = await api.get(`/partner/${cmpn_id}`);

        console.log(response);

        if (response != null) {
            const data = response.data;

            name = data.name;
            owner = data.owner?.trim() || "-";
            tel = common.formatPhoneNumber(data.tel?.trim() || "-");
            addr = (data.addr1 || "" + " " + data.addr2 || "").trim() || "-";
            bizno = common.formatBusinessNumber(data.bizno?.trim() || "-");
            note = data.note.replaceAll("<br>", "\r\n");
        }
    }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<!-- svelte-ignore a11y-missing-attribute -->
<!-- svelte-ignore a11y-label-has-associated-control -->
<div class="main-body custom-partner-detail">
    <div class="main-content">
        <header class="detail-header">
            <button class="back-btn" on:click={() => window.history.back()}>
                <svg
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    stroke="currentColor"
                    stroke-width="2"
                    fill="none"
                >
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>
            <h1>업체 상세 정보</h1>
        </header>

        <div class="detail-scroll-area scroll-custom">
            <!-- 1. 업체 기본 정보 섹션 -->
            <section class="detail-section">
                <div class="section-header">
                    <h2 class="section-title">업체 기본 정보</h2>
                </div>

                <div class="info-group">
                    <label>협력업체명</label>
                    <div class="info-value-box highlight">{name}</div>
                </div>

                <div class="info-group">
                    <label>대표자</label>
                    <div class="info-value-box">{owner}</div>
                </div>

                <div class="info-group">
                    <label>연락처</label>
                    <a href="tel:{tel}" class="info-value-box tel-link">
                        {tel}
                        <svg
                            viewBox="0 0 24 24"
                            width="18"
                            height="18"
                            stroke="currentColor"
                            stroke-width="2"
                            fill="none"
                        >
                            <path
                                d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.79 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                            ></path>
                        </svg>
                    </a>
                </div>
            </section>

            <!-- 2. 사업자 및 주소 섹션 -->
            <section class="detail-section">
                <div class="section-header">
                    <h2 class="section-title">사업자 및 주소</h2>
                </div>

                <div class="info-group">
                    <label>사업자등록번호</label>
                    <div class="info-value-box">{bizno}</div>
                </div>

                <div class="info-group">
                    <label>주소</label>
                    <div class="info-value-box address-box">{addr}</div>
                </div>
            </section>

            <!-- 3. 기타 정보 섹션 -->
            <section class="detail-section">
                <div class="section-header">
                    <h2 class="section-title">기타 정보</h2>
                </div>
                <div class="info-group">
                    <label>비고 (메모)</label>
                    <div class="info-value-box note-box">
                        {note || "등록된 메모가 없습니다."}
                    </div>
                </div>
            </section>
        </div>

        <Btm />
    </div>
</div>

<style>
    .custom-partner-detail.main-body {
        background-color: var(--bg-primary) !important;
        min-height: 100vh;
    }
    .custom-partner-detail .main-content {
        max-width: 1024px;
        margin: 0 auto;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: var(--bg-primary);
    }

    /* Header */
    .custom-partner-detail .detail-header {
        background-color: var(--bg-secondary);
        padding: 18px 16px;
        display: flex;
        align-items: center;
        gap: 16px;
        border-bottom: 1px solid var(--border-color);
        position: sticky;
        top: 0;
        z-index: 100;
    }
    .custom-partner-detail .back-btn {
        background: none;
        border: none;
        color: var(--text-primary);
        cursor: pointer;
        padding: 4px;
        display: flex;
        align-items: center;
    }
    .custom-partner-detail h1 {
        font-size: 18px;
        font-weight: 700;
        color: var(--text-primary);
        margin: 0;
    }

    /* Scroll Area */
    .custom-partner-detail .detail-scroll-area {
        flex: 1;
        overflow-y: auto;
        padding: 16px;
        padding-bottom: 100px;
    }

    /* Section */
    .custom-partner-detail .detail-section {
        background-color: var(--bg-secondary);
        border-radius: 16px;
        padding: 24px;
        margin-bottom: 16px;
        box-shadow: var(--shadow-sm);
        border: 1px solid var(--border-color);
    }
    .custom-partner-detail .section-title {
        font-size: 15px;
        font-weight: 800;
        color: var(--color-primary);
        margin-bottom: 20px;
        padding-left: 10px;
        border-left: 4px solid var(--color-primary);
    }

    /* Info Groups */
    .custom-partner-detail .info-group {
        margin-bottom: 18px;
    }
    .custom-partner-detail .info-group:last-child {
        margin-bottom: 0;
    }
    .custom-partner-detail label {
        display: block;
        font-size: 13px;
        font-weight: 600;
        color: var(--text-tertiary);
        margin-bottom: 8px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }

    .custom-partner-detail .info-value-box {
        width: 100%;
        padding: 14px 16px;
        background-color: var(--bg-primary);
        border: 1px solid var(--border-color);
        border-radius: 10px;
        color: var(--text-primary);
        font-size: 15px;
        font-weight: 500;
        min-height: 50px;
        display: flex;
        align-items: center;
        line-height: 1.5;
    }

    .custom-partner-detail .info-value-box.highlight {
        font-weight: 700;
        font-size: 17px;
        color: var(--text-primary);
        background-color: var(--bg-secondary);
        border-color: var(--color-primary);
    }

    .custom-partner-detail .tel-link {
        text-decoration: none;
        justify-content: space-between;
        color: var(--color-primary);
        font-weight: 700;
    }
    .custom-partner-detail .tel-link:hover {
        background-color: var(--color-primary-light);
    }

    .custom-partner-detail .address-box {
        align-items: flex-start;
    }

    .custom-partner-detail .note-box {
        min-height: 120px;
        align-items: flex-start;
        white-space: pre-wrap;
        word-break: break-all;
    }
</style>
